import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from "react-router-dom";

const AdminRouteWithLayout = ({
  layout: Layout,
  component: Component,
  isAuthenticated,
  isVerifying,
  user,
  ...rest
}) => (
  <Route
    {...rest}
    render={props =>
      isVerifying ? (
        <div />
      ) : isAuthenticated && user.admin ? (
        <Layout user={user}>
          <Component {...props} />
        </Layout>
      ) : (
        isAuthenticated ? (
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location }
            }}
          />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location }
            }}
          />
        )
      )
    }
  />
);

AdminRouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  path: PropTypes.string,
  user: PropTypes.object,
};

export default AdminRouteWithLayout;
